<template>
    <div class="settings-panel">
        <div class="settings-panel__inner">
            <portfolio-fees
                v-if="loaded"
                :mwcId="getMwcIdForChild('PortfolioFees')"
                :environment="this.settings.environment"
                :userInfo="userInfo"
                :isCollapsibleMode="true"
                :mainSectionExpanded="false"
                :showAnnualAccountFee="false"
                :showAnnualAssetBaseFee="true"
                :showAnnualFeeFrequency="true"
                :showPayFeeMethod="true"
                :showPayFeeTime="true"
                :showPlanFee="false"
                :showAnnuity="false"
                :showHoldingLevelFees="!$store.getters['settings/isSimpleAssumptionWorkflow']"
                :holdingsSectionExpanded="true"
                :showPayCashFirst="true"
                :showLoiAsFrontLoad="true"
                :showChargeForRebalancing="true"
                :securities="$store.state.holdings.securities"
                :showRoaLoi="false"
                :portfolioFees="$store.state.fees"
                @security-fees-changed="handleSecurityChanged"
                @advisory-fee-changed="handleAdvisoryFeeChanged"
                @transaction-fee-changed="handleTransactionFeeChanged"
            >
            </portfolio-fees>
        </div>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import PortfolioFees from "hypo-portfolio-fees/src/PortfolioFees";
import { mapState } from "vuex";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import * as types from "../store/mutation-types.js";
import isEqual from "lodash.isequal";
import { TokenSourceMixin } from "hypo-shared-utils/src/index";
import { useCdnAsset } from "../../../microfrontend.js";

export default {
    name: "fees-panel",
    props: {
        text: String
    },
    components: {
        PortfolioFees
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin, TokenSourceMixin("/api/v1/auth/getcomponenttoken", process.env.VUE_APP_USAGE === "application")],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            loaded: false,
            userInfo: null
        };
    },
    computed: {
        ...mapState("fees", ["includeAdvisoryFee", "includeTransactionFee"])
    },
    async created() {
        const UserConfiguration = useCdnAsset("awse_core", "UserConfiguration");
        const decodeTokenData = await UserConfiguration.getJwtDecodedToken();
        const roles = decodeTokenData["https://morningstar.com/role"];
        const userId = decodeTokenData["https://morningstar.com/mstar_id"];
        this.userInfo = {
            userId,
            userLevel: roles.includes("FirmAdmin") ? 0 : 2 //not accurate, backend support later
        };
        this.loaded = true;
    },
    methods: {
        handleSecurityChanged(data) {
            if (!isEqual(data, this.$store.state.holdings.securities)) {
                this.$store.commit(`holdings/${types.SET_SECURITIES}`, data);
            }
        },
        setSecurityLevelAdvisoryFeeToDefault() {
            const { annualFeeAmount, annualFeeChargeFrequency } = this.$store.state.settings.preferences.feeSetting;
            const newSecs = this.$store.state.holdings.securities.map(security => {
                return {
                    ...security,
                    fees: {
                        ...security.fees,
                        annualFeeAmount,
                        annualFeeChargeFrequency,
                        annualFeeAmountType: 1
                    }
                };
            });
            this.$store.commit(`holdings/${types.SET_SECURITIES}`, newSecs);
        },
        handleAdvisoryFeeChanged(data) {
            const originalInclude = this.$store.state.fees.includeAdvisoryFee;
            this.$store.commit(`fees/${types.SET_INCLUDE_ADVISORY_FEE}`, data.includeAdvisoryFee);
            // from false to true, set security level advisory fee related values to default
            if (!originalInclude && data.includeAdvisoryFee) {
                this.setSecurityLevelAdvisoryFeeToDefault();
            }
            this.$store.commit(`fees/${types.SET_ANNUAL_FEE_AMOUNT}`, data.annualFeeAmount);
            this.$store.commit(`fees/${types.SET_ANNUAL_FEE_CHARGE_FREQUENCY}`, parseInt(data.annualFeeChargeFrequency, 10));
            this.$store.commit(`fees/${types.SET_ANNUAL_FEE_PAY_METHOD}`, parseInt(data.annualFeePayMethod, 10));
            this.$store.commit(`fees/${types.SET_ANNUAL_FEE_PAY_ON_BEGIN}`, /true/i.test(data.annualFeePayOnBegin));
            this.$store.commit(`fees/${types.SET_ANNUAL_FEE_PAY_CASH_FIRST}`, /true/i.test(data.annualFeePayCashFirst));
        },
        handleTransactionFeeChanged(data) {
            const { chargeOnRebalancing, frontLoadType, includeTransactionFee, redemptionCharge } = this.$store.state.fees;
            if (!isEqual(data, { chargeOnRebalancing, frontLoadType, includeTransactionFee, redemptionCharge })) {
                this.$store.commit(`fees/${types.SET_CHARGE_ON_REBALANCING}`, /true/i.test(data.chargeOnRebalancing));
                this.$store.commit(`fees/${types.SET_FRONT_LOAD_TYPE}`, data.frontLoadType);
                this.$store.commit(`fees/${types.SET_INCLUDE_TRANSACTION_FEE}`, data.includeTransactionFee);
                this.$store.commit(`fees/${types.SET_REDEMPTION_CHARGE}`, data.redemptionCharge);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@mds/typography";
</style>
